<template>
  <canvas :id="$attrs.id" :width="width" :height="height" />
</template>
<script>
import {
  Chart,
  ArcElement,
  LineElement,
  BarElement,
  PointElement,
  BarController,
  BubbleController,
  DoughnutController,
  LineController,
  PieController,
  PolarAreaController,
  RadarController,
  ScatterController,
  CategoryScale,
  LinearScale,
  LogarithmicScale,
  RadialLinearScale,
  TimeScale,
  TimeSeriesScale,
  Decimation,
  Filler,
  Legend,
  Title,
  Tooltip,
} from 'chart.js';

Chart.register(
  ArcElement,
  LineElement,
  BarElement,
  PointElement,
  BarController,
  BubbleController,
  DoughnutController,
  LineController,
  PieController,
  PolarAreaController,
  RadarController,
  ScatterController,
  CategoryScale,
  LinearScale,
  LogarithmicScale,
  RadialLinearScale,
  TimeScale,
  TimeSeriesScale,
  Decimation,
  Filler,
  Legend,
  Title,
  Tooltip,
);
const plugin = {
  id: 'custom_canvas',
  beforeDraw: (chart) => {
    const { ctx } = chart;
    const { chartArea } = chart;
    ctx.save();

    if (chart.config.options.chartArea && chart.config.options.chartArea.backgroundColor) {
      ctx.fillStyle = chart.config.options.chartArea.backgroundColor;
      ctx.fillRect(chartArea.left, chartArea.top, chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
    }

    if (chart.config.options.linearRegressionBorder) {
      ctx.strokeStyle = chart.config.options.linearRegressionBorder.borderColor;
      ctx.lineWidth = chart.config.options.linearRegressionBorder.borderWidth;
      ctx.roundRect(chartArea.left, chartArea.top, chartArea.width, chartArea.height, 5);
      ctx.stroke();
    }

    ctx.restore();
  },
};
let myChart;
export default {
  props: {
    width: { type: String, default: '400' },
    height: { type: String, default: '400' },
    type: { type: String, default: '' },
    data: { type: Object, default: () => ({}) },
    options: { type: Object, default: () => ({}) },
  },
  watch: {
    data() {
      this.updateChart();
    },
  },
  mounted() {
    const ctx = document.getElementById(this.$attrs.id);
    // eslint-disable-next-line no-unused-vars
    myChart = new Chart(ctx, {
      type: this.type,
      data: this.data,
      options: this.options,
      plugins: [plugin],
    });
  },
  methods: {
    updateChart() {
      myChart.update();
    },
  },
};
</script>
